import React, { useState, useContext, useCallback } from "react";
import { Snackbar } from "../ppui";

const ToastContext = React.createContext(undefined);

export const ToastProvider = ({ children }) => {
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarDuration, setSnackbarDuration] = useState(3000);
  const [snackColor, setSnackColor] = useState("success");

  const showToastMessage = useCallback(
    ({ message, duration = 3000, color = "success" }) => {
      setSnackbarMessage(message);
      setSnackbarDuration(duration);
      setSnackColor(color);
      setSnackbarVisible(true);
    },
    []
  );

  return (
    <ToastContext.Provider value={{ showToastMessage }}>
      {children}

      <Snackbar
        message={snackbarMessage}
        color={snackColor}
        variant="contained"
        size="medium"
        position="top-right"
        onClose={() => setSnackbarVisible(false)}
        onOpen={snackbarVisible}
        loading={false}
        duration={snackbarDuration}
      />
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (context === undefined) {
    throw new Error("useToast must be used within a ToastProvider");
  }
  return context;
};
